module.exports = __webpack_public_path__ + "img/ws.ae503bc9.svg";